import Choices from 'choices.js';

export const moduleSpacesFeed = () => {


	let privateEventSpacesModules = document.querySelectorAll('.m__spaces-feed');
	if(privateEventSpacesModules){
		privateEventSpacesModules.forEach((module) => {
			const occasionFilterEl = module.querySelector('#occasionFilter'),
			locationFilterEl = module.querySelector('#locationFilter'),
			capacityFilterEl = module.querySelector('#capacityFilter'),
			spacesCards = module.querySelectorAll('.js__spaces-card'),
			resetFilters = module.querySelectorAll('.js__reset-filters'),
			spacesCardsGrid = module.querySelector('.m__spaces-feed__grid'),
			noSpacesFoundMessage = module.querySelector('.m__spaces-feed__none-found'),
			loadMoreButton = module.querySelector('.js__load-more-spaces');


			if(occasionFilterEl && locationFilterEl && capacityFilterEl){


				const choicesConfig = {
					itemSelectText: '',
					shouldSort: false,
					searchEnabled: false,
				},
				occasionFilter = new Choices(occasionFilterEl,choicesConfig),
				locationFilter = new Choices(locationFilterEl,choicesConfig),
				capacityFilter = new Choices(capacityFilterEl,choicesConfig);


				let filterDropdowns = [
					occasionFilterEl,
					locationFilterEl,
					capacityFilterEl
				];

				filterDropdowns.forEach((filterDropdown) =>{

					filterDropdown.addEventListener("change", (event) => {

						loadMoreButton.parentElement.classList.add('hidden');

						let currentCapacityFilter = capacityFilterEl.value,
							currentOccasionFilter = occasionFilterEl.value,
							currentLocationFilter = locationFilterEl.value,
							hiddenCardCount = 0;				

						//Reset no spaces found message
						spacesCardsGrid.classList.remove('ig-hidden');
						noSpacesFoundMessage.classList.add('hidden');


						spacesCards.forEach((card) => {
							card.classList.remove('hidden');
							let brandArr = JSON.parse(card.dataset.brand),
							matchesBrand = brandArr.some(item => currentOccasionFilter.includes(item));

							if(currentOccasionFilter != 0 && !matchesBrand){ //Filter out any that don't meet the Occassion filter
								card.classList.add('hidden');
								hiddenCardCount++;
							}else if(currentLocationFilter != 0 && card.dataset.location != currentLocationFilter){ //"" with Locations filter
								card.classList.add('hidden');
								hiddenCardCount++;
							}else if(currentCapacityFilter != 0 && parseInt(card.dataset.capacity) < currentCapacityFilter){ //Capacity
								card.classList.add('hidden');
								hiddenCardCount++;
							}
						});

						//Show the no spaces found message
						if(hiddenCardCount == spacesCards.length){
							spacesCardsGrid.classList.add('ig-hidden');
							noSpacesFoundMessage.classList.remove('hidden');
						}


						//Rese
						if(currentLocationFilter != 0 || currentOccasionFilter != 0){
							resetFilters.forEach((resetFilter)=>{
								resetFilter.classList.remove('active');
							});
						}else{
							resetFilters.forEach((resetFilter)=>{
								resetFilter.classList.add('active');
							});
						}
						

						

					});
				})


				resetFilters.forEach((resetFilter)=>{
					resetFilter.addEventListener('click', (event) => {

						event.target.classList.add('active');

						spacesCardsGrid.classList.remove('ig-hidden');
						noSpacesFoundMessage.classList.add('hidden');

						occasionFilter.setChoiceByValue('0');
						locationFilter.setChoiceByValue('0');
						capacityFilter.setChoiceByValue('10');

						spacesCards.forEach((card) => {
							card.classList.remove('hidden');
						});
					})
				})


				loadMoreButton.addEventListener('click',(event) => {
					let currentcapacityFilter = capacityFilterEl.value,
						currentoccasionFilter = occasionFilter.getValue(true),
						currentLocationFilter = locationFilterEl.value;	

					spacesCards.forEach((card) => {
						const brandArr = JSON.parse(card.dataset.brand);
						const matchesBrand = brandArr.some(item => currentoccasionFilter.includes(item));

						if(currentoccasionFilter == 0 || matchesBrand){
							card.classList.remove('hidden');
						}
					});
					event.target.parentElement.classList.add('hidden');
				})
			}
		})
	}
	
}







